<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="createMark" (change)="createMarkChange()" (submit)="createMarkSubmit()">



        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{"CREATE_MARK" | translate | titlecase }}</h6>
            </div>
            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                <button type="button" class="btn btn-outline-secondary m-2 rounded-0" routerLink="/academics/marks"
                    *ngIf="!creating">
                    {{"CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!creating"><i
                        class="fas fa-user-plus"></i>
                    {{"SAVE" | translate | titlecase }}</button>
                <app-loader [show]="creating"></app-loader>
            </div>


        </div>

        <div class="row mt-4">

            <div class="col-12">

                <div class="row bg-white border m-0 py-3 ">
                    <!-- <div class="col-md-10 mx-md-auto pt-md-5 px-md-5">
                        <img src="assets/images/avatar.png" class="img-fluid">
                    </div> -->

                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "MARK_GROUP" | translate | titlecase
                                }}</label>
                            <select class="form-control custom-select" formControlName="markGroup"
                                >
                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                    }}
                                </option>
                                <option *ngFor="let field of markGroups" [ngValue]="field.id">
                                    {{
                                    (globals.lang == 'ar')? field?.mgroupNameAr : field?.mgroupNameEn
                                    }}
                                </option>
                            </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createMark.controls.markGroup.touched && createMark.controls.markGroup.invalid && createMark.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"LETTER_GRADE" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="letterGrade">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createMark.controls.letterGrade.touched && createMark.controls.letterGrade.invalid && createMark.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"ARABIC_NAME" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="nameAr">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createMark.controls.nameAr.touched && createMark.controls.nameAr.invalid && createMark.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"ENGLISH_NAME" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="nameEn">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createMark.controls.nameEn.touched && createMark.controls.nameEn.invalid && createMark.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"PERCENTAGE" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="percentage">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createMark.controls.percentage.touched && createMark.controls.percentage.invalid && createMark.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>

                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"GPA" | translate | titlecase }} - {{"FROM" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="gpaFrom">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createMark.controls.gpaFrom.touched && createMark.controls.gpaFrom.invalid && createMark.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>

                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"GPA" | translate | titlecase }} - {{"TO" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="gpaTo">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createMark.controls.gpaTo.touched && createMark.controls.gpaTo.invalid && createMark.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            
                            
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<app-loader [attr.show]="showLoader"></app-loader>